import React from 'react';

import MaleIcon from '../../assets/images/team-image/2.png';
import FemaleIcon from '../../assets/images/team-image/1.png';

import Loadable from '@loadable/component'
const OwlCarousel = Loadable(() => import('react-owl-carousel3'))

const teamMembers = [    { name: 'Bahattin D.', title: 'Yönetim Kurulu', gender: 'male' },
    { name: 'Hidayet D.', title: 'Finans Yönetim', gender: 'male' },
    { name: 'Tahsin P.', title: 'Ceo', gender: 'male' },
    { name: 'Serdar Y.', title: 'Full Stack Developer', gender: 'male' },
    { name: 'Emre Cemil S.', title: 'Yazılım Mühendisi', gender: 'male' },
    { name: 'Esma K.', title: 'Yazılım Mühendisi & Medya', gender: 'female' },
    { name: 'Beyza K.', title: 'Yazılım Mühendisi & Arge', gender: 'female' },
    { name: 'Fatih G.', title: 'Teknik Ressam', gender: 'male' },
    { name: 'Ali Ö.', title: 'Teknik Ressam', gender: 'male' },
    { name: 'Abdurranman Ö.', title: 'Teknik Ressam', gender: 'male' },
    { name: 'M. Ali P.', title: 'Makine Mühendisi', gender: 'male' },
    { name: 'Furkan M.', title: 'Bilgisayar Mühendisi', gender: 'male' },
    { name: 'Rana B.', title: 'İletişim & Satış', gender: 'female' },
    { name: 'Emine Y.', title: 'Yazılım Mühendisi', gender: 'female' },
    { name: 'Hilal K.', title: 'Muhasebe', gender: 'female' },
    { name: 'Bahar Dokur', title: 'Aday Mühendis', gender: 'female' },
    { name: 'Ahmet K.', title: 'Aday Mühendis', gender: 'male' },
];
const options = {
    items: 5,
    loop: true,
    nav: false,
    dots: true,
    margin: 30,
    autoplay: false,
    smartSpeed: 1000,
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2
        },
        900: {
            items: 3
        },
        1200: {
            items: 4
        },
        1500: {
            items: 5
        }
    }
}

const Team = () => {
    const [display, setDisplay] = React.useState(false);

    React.useEffect(() => {
        setDisplay(true);
    }, [])

    return (
        <div className="team-area ptb-80 bg-f9f6f6">
            <div className="container">
                <div className="section-title">
                    <h2>Ekibimiz</h2>
                    <div className="bar"></div>
                    <p>Ortamda bulunmaktan, beraber proje geliştirmekten keyf aldığımız, desteklerini esirgemeyen kendi alanında uzman ekibimiz </p>
                </div>
            </div>

            {display ? <OwlCarousel 
                className="team-slider owl-carousel owl-theme owl-theme-style"
                {...options}
            >
                {teamMembers.map((member) => (
                    <div className="single-team" key={member.name}>
                        <div className="team-image">
                            <img
                                className="team-member-icon"
                                src={member.gender === 'female' ? FemaleIcon : MaleIcon}
                                alt={member.name}
                            />
                        </div>

                        <div className="team-content">
                            <div className="team-info">
                                <h3>{member.name}</h3>
                                <span>{member.title}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </OwlCarousel> : ''}
        </div>
    )
}

export default Team;
